if (!customElements.get('meridian-quantity-offer')) {
  customElements.define('meridian-quantity-offer', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.input = this.productInfo?.querySelector('.quantity__input');
      if (!this.input) return;
      this.unitPrice = Number(this.dataset.price);
      this.available = this.dataset.available === 'true';
      this.onInput = () => this.sync();
      this.onClick = (event) => {
        const button = event.target.closest('button[data-quantity]');
        if (!button || button.disabled || !this.contains(button)) return;
        this.input.value = button.dataset.quantity;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      };
      this.input.addEventListener('change', this.onInput);
      this.input.addEventListener('input', this.onInput);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.onInput);
      this.observer.observe(this.input, { attributes: true });
      if (typeof subscribe === 'function') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          const price = data.html.querySelector('meridian-quantity-offer [data-unit-price]');
          if (price) this.querySelector('[data-unit-price]').textContent = price.textContent;
          this.unitPrice = data.variant.price;
          this.available = data.variant.available;
          this.sync();
        });
      }
      this.sync();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onInput);
      this.input?.removeEventListener('input', this.onInput);
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.unsubscribeVariant?.();
      this.updatePrice(NaN);
    }

    sync() {
      const value = Number(this.input.value);
      const min = Number(this.input.min || 1);
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const step = Number(this.input.step || 1);
      this.querySelectorAll('button[data-quantity]').forEach((button) => {
        const quantity = Number(button.dataset.quantity);
        button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
        button.setAttribute('aria-pressed', String(value === quantity));
      });
      this.updatePrice(value >= min && value <= max && (value - min) % step === 0 ? value : NaN);
    }

    updatePrice(quantity) {
      const priceBlock = this.productInfo?.querySelector(`#price-${this.dataset.section}`);
      const total = priceBlock?.querySelector('[data-quantity-total]');
      const nativePrice = priceBlock?.querySelector(':scope > .price');
      if (!total || !nativePrice) return;
      const showEstimate = this.available && Number.isSafeInteger(quantity) && quantity > 0 &&
        Number.isSafeInteger(this.unitPrice) && this.unitPrice >= 0 && Number.isSafeInteger(this.unitPrice * quantity);
      total.classList.toggle('hidden', !showEstimate);
      nativePrice.classList.toggle('hidden', showEstimate);
      if (!showEstimate) return;
      const percent = quantity >= 3 ? 25 : quantity === 2 ? 15 : 0;
      // Estimated USD pricing: per-unit discount cents rounded down, matching the verified cart.
      // Shopify's actual cart discounts remain authoritative; this never changes the cart.
      const original = this.unitPrice * quantity;
      const estimate = (this.unitPrice - Math.floor(this.unitPrice * percent / 100)) * quantity;
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: 'USD'
      }).format(cents / 100);
      const originalTotal = total.querySelector('[data-original-total]');
      originalTotal.textContent = money(original);
      originalTotal.classList.toggle('hidden', percent === 0);
      total.querySelector('[data-total-price]').textContent = `${money(estimate)} USD`;
      total.querySelector('[data-total-summary]').textContent =
        `${quantity} ${quantity === 1 ? 'unit' : 'units'}${percent ? ` · Save ${percent}%` : ''}`;
    }
  });
}
